<div class="advanced_filter">
  <form [formGroup]="filterForm">
    <div formArrayName="filterConditions" class="filterConditions">
      <div class="big_add_icon_container" *ngIf="filterConditions.length === 0">
        <div class="big_add_icon" (click)="addCondition()">
          <app-svg-icon [path]="'assets/icons/plus_icon.svg'"></app-svg-icon>
          <span>Add Condition</span>
        </div>
      </div>
      <div *ngFor="let condition of filterConditions.controls; let i = index" [formGroupName]="i"
           class="filter_conditions">

        <div class="columns_holder">
          <div class="column_holder_sl_no">
            <div class="sl_no">{{ i + 1 }}</div>
            <app-multi-select
              formControlName="name"
              [options]="filterFields"
              [valueKey]="'name'"
              [displayKey]="'displayLabel'"
              [isMultiSelect]="false"
              [placeholder]="'Select Field'"
              [showChips]="false"
              [disable]="false"
              [returnRawValue]="false"
              (selectionChange)="fieldSelection($event, i)"
            ></app-multi-select>
          </div>
          <div class="form_validation_error_new"
               [ngClass]="{
                visible:
                  condition.get('name')?.invalid &&
                  condition.get('name')?.invalid?.touched
              }">
            <small *ngIf="condition.get('name')?.errors?.['required']">
              Field is required
            </small>
          </div>
        </div>

        <div class="operators_holder">
          <app-multi-select
            formControlName="operator"
            [options]="fieldOperatorMap.get(condition.get('name')?.value) || []"
            [valueKey]="'key'"
            [displayKey]="'label'"
            [isMultiSelect]="false"
            [showChips]="false"
            [placeholder]="'Select Operator'"
          ></app-multi-select>
          <div class="form_validation_error_new" [ngClass]="{visible: condition.get('operator')?.invalid && condition.get('operator')?.touched}">
            <small *ngIf="condition?.get('operator')?.errors?.['required'] ?? false">
              Operator is required
            </small>
          </div>
        </div>

        <div class="value_holder">
          <div class="form_fields_action_btns">
            <ng-container *ngIf="getFieldInfo(condition.get('name')?.value) as fieldInfo; else defaultField">

              @if (fieldInfo?.hasLookup) {
                <app-autocomplete-dropdown
                  class="value-input"
                  [formControlName]="'value'"
                  [placeholder]="'Search value'"
                  [apiUrl]="fieldInfo?.searchConfig.apiUrl"
                  [selectFields]="fieldInfo?.searchConfig.selectFields"
                  [filterByKeys]="fieldInfo?.searchConfig.filterByKeys"
                  [limit]="fieldInfo?.searchConfig.limit"
                  [orderBy]="fieldInfo?.searchConfig.orderBy"
                  [filterByKey]="fieldInfo?.searchConfig.filterByKey"
                  [returnRawValue]="false"
                  [additionalFilters]="fieldInfo?.searchConfig?.additionalFilters"
                  [multiSelect]="fieldInfo?.searchConfig.multiSelect"
                  [bindLabel]="fieldInfo?.searchConfig.bindLabel"
                  [bindValue]="fieldInfo?.searchConfig.bindValue"
                  [displayColumns]="fieldInfo?.searchConfig.displayColumns"
                ></app-autocomplete-dropdown>
              } @else if (fieldInfo?.dataType === 'NUMBER') {
                <input
                  class="value-input"
                  type="number"
                  formControl="'value'"
                  [formControlName]="'value'"
                  [ngClass]="{'form_error': condition.get('value')?.invalid && condition.get('value')?.touched}"
                />
              } @else if (fieldInfo?.dataType === 'BOOLEAN') {
                <app-multi-select
                  [formControlName]="'value'"
                  [options]="[{
                    label: 'True',
                    value: true
                  }, {
                    label: 'False',
                    value: false
                  }]"
                  [displayKey]="'label'"
                  [valueKey]="'value'"
                  [isMultiSelect]="false"
                  [placeholder]="'Pick One'"
                ></app-multi-select>
              } @else if (fieldInfo?.dataType === 'DROPDOWN' || fieldInfo?.dataType === 'PICKLIST') {
                <app-multi-select
                  [formControlName]="'value'"
                  [options]="fieldInfo?.options"
                  [displayKey]="'label'"
                  [valueKey]="'value'"
                  [isMultiSelect]="true"
                  [placeholder]="'Select'"
                ></app-multi-select>
              } @else if (fieldInfo?.dataType === 'DATE') {
                <app-date-picker [required]="true"
                                 [type]="'date'"
                                 [formControlName]="'value'"
                ></app-date-picker>
              } @else if (fieldInfo?.dataType === 'DATETIME') {
                <app-date-picker [required]="true"
                                 [type]="'datetime-local'"
                                 [formControlName]="'value'"
                ></app-date-picker>
              } @else {
                <input
                  class="value-input"
                  [formControlName]="'value'"
                  placeholder="Enter value"
                  [ngClass]="{'form_error': condition.get('value')?.invalid && condition.get('value')?.touched}"
                />
              }

            </ng-container>

            <ng-template #defaultField>
              <input
                class="value-input"
                [formControlName]="'value'"
                placeholder="Enter value"
              />
            </ng-template>

            <div (click)="addCondition()" class="btn add_btn">
              <app-svg-icon [path]="'/assets/icons/add_plus_icon.svg'"></app-svg-icon>
            </div>

            <div (click)="removeCondition(i)" class="btn"
                 *ngIf="getFieldInfo(condition.get('name')?.value)?.deletable ?? true">
              <app-svg-icon [path]="'/assets/icons/delete_icon.svg'"></app-svg-icon>
            </div>
          </div>

          <div class="form_validation_error_new" [ngClass]="{visible: condition.get('value')?.invalid && condition.get('value')?.touched}">
            <small *ngIf="condition?.get('value')?.errors?.['required'] ?? false">
              Value is required
            </small>
          </div>
        </div>



      </div>
    </div>
  </form>
</div>
<div class="fixed_modal_footer" *ngIf="view === 'modalView'">
  <div class="centered_flex_container modal_actions">
    <button
      type="button"
      class="inversed_danger_button"
      (click)="resetFilter()"
    >
      Reset
    </button>
    <button type="button" class="secondary_button" (click)="close()">
      Cancel
    </button>
    <button type="submit" class="primary_button" (click)="applyFilter()">
      Apply
    </button>
  </div>
</div>
